import React, { forwardRef } from 'react';
import americanaIcon from './americana-favicon.ico';
import './AmericanaLinkButton.css';

const AmericanaLinkButton = forwardRef<HTMLButtonElement>((_props, ref) => {
  const handleClick = () => {
    const hash = window.location.hash.slice(1);
    const [locationPart] = hash.split('?');
    const url = locationPart
      ? `https://americanamap.org/#map=${locationPart}`
      : 'https://americanamap.org/';
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      ref={ref}
      className="americana-link-button"
      onClick={handleClick}
      title="Go to americanamap.org"
      aria-label="Go to americanamap.org"
    >
      <img src={americanaIcon} alt="" width={20} height={20} />
    </button>
  );
});

export default AmericanaLinkButton;
